import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";
import Icon from "./Icon";
import { TerritoryOptions } from "../../Constants/retailer";
import MediaSelect from "../../components/MediaSelect";
import "./index.css";

const smile_whiteIcon = require("../../assets/media/landing/white/smile_white.png");
const smile_blackIcon = require("../../assets/media/landing/black/smile_black.png");
const video_whiteIcon = require("../../assets/media/landing/white/video_white.png");
const video_blackIcon = require("../../assets/media/landing/black/video_black.png");

const LoginBot = () => {
  const location = useLocation();
  const history = useHistory();

  const [loginWelcome, setLoginWelcome] = useState("");
  const [isTakserLogin, setIsTakserLogin] = useState(false);
  const [changed, setChanged] = useState(false);
  const [mediaType, setMediaType] = useState("");
  const [mediaUrl, setMediaUrl] = useState("");

  const [brand, setBrand] = useState(null);
  const [role, setRole] = useState(null);
  const [username, setUserName] = useState("");
  const [brandData, setBrandData] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!location.state) {
      history.push("/");
    } else {
      const { brand, role, username } = location.state;
      setBrand(brand);
      setRole(role);
      setUserName(username);

      Firebase.getBrandDataByID(brand, (brand_data) => {
        setLoading(false);
        if (brand_data) {
          setBrandData(brand_data);

          setLoginWelcome(brand_data.login_welcome || "");
          setMediaType(brand_data.login_media_type || "");
          setMediaUrl(brand_data.login_media_url || "");
        }
      });
    }
  }, [location]);

  const onChange = (e) => {
    setLoginWelcome(e.target.value);
    setChanged(true);
  };
  const handleCheck = () => {
    setIsTakserLogin(!isTakserLogin);
    Firebase.updateBrandDataById(brand, { tasker_login: !isTakserLogin });
  };
  const saveLoginWelcomeMessage = () => {
    console.log("login_welcome", loginWelcome);
    if (loginWelcome) {
      Firebase.updateBrandDataById(brand, {
        login_welcome: loginWelcome,
        login_media_type: mediaType,
        login_media_url: mediaUrl,
      }).then((res) => {
        setChanged(false);
      });
    }
  };

  const handleSetMedia = (type, url) => {
    setMediaType(type);
    setMediaUrl(url);
    if (
      (brandData.login_media_type && brandData.login_media_type !== type) ||
      (brandData.login_media_url && brandData.login_media_url !== url)
    ) {
      setChanged(true);
    }
    if (
      (!brandData.login_media_type && type !== "") ||
      (!brandData.login_media_url && url !== "")
    ) {
      setChanged(true);
    }
    // if (brand) {
    //   Firebase.updateBrandDataById(brand, {
    //     welcome_media_type: type,
    //     welcome_media_url: url,
    //   });
    // }
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <div id="page-container">
      <Header
        username={username}
        role={role}
        onHome={goBack}
        logo={brandData.logo}
        brand={brand}
        brandName={brandData.name}
        is_property_brand={brandData.is_property_brand || false}
      />
      <main id="main-container">
        <div className="welcome-chatbot-group">
          <div className="chatbot-inputs">
            <img
              src={brandData.icon}
              width="50"
              style={{ borderRadius: 25 }}
              alt="icon"
            />
            <textarea
              rows="1"
              className="welcome-chatbot-input"
              disabled
              value={`Welcome to the ${brandData.name} community.`}
            ></textarea>
          </div>
          <div className="chatbot-inputs">
            <Icon
              icon={brandData.white ? smile_whiteIcon : smile_blackIcon}
              background={brandData.hex}
            />
            <textarea
              rows="1"
              className="welcome-chatbot-input"
              name="0"
              onChange={onChange}
              value={loginWelcome}
            ></textarea>
          </div>
          <div className="chatbot-inputs">
            <Icon
              icon={brandData.white ? video_whiteIcon : video_blackIcon}
              background={brandData.hex}
            />
            <div style={{ marginLeft: 10, width: 400 }}>
              <MediaSelect
                uploadFoler={`"login-bot/${brandData.name}`}
                onChangeContent={handleSetMedia}
                existingContent={
                  mediaType !== "" && mediaUrl !== ""
                    ? {
                        mediaType,
                        mediaUrl,
                      }
                    : undefined
                }
              />
            </div>
          </div>
          <div className="chatbot-inputs">
            <img
              src={brandData.icon}
              width="50"
              style={{ borderRadius: 25 }}
              alt="icon"
            />
            <textarea
              rows="1"
              className="welcome-chatbot-input"
              disabled
              value={`Are you a member of ${brandData.name}?`}
            ></textarea>
          </div>
          {changed && (
            <button className="btn btn-save" onClick={saveLoginWelcomeMessage}>
              Save
            </button>
          )}
          <div className="checkbox-input">
            <input
              type="checkbox"
              checked={isTakserLogin}
              onChange={handleCheck}
            />
            <p>Include tasker login/register on user onboarding</p>
          </div>
        </div>
      </main>
    </div>
  );
};
export default LoginBot;



// WEBPACK FOOTER //
// ./src/screens/LoginBot/index.js